import React, { forwardRef } from 'react';
import { Box } from '@fiverr-private/theme';
import { ButtonProps } from '@fiverr-private/button';
import { Container } from '@fiverr-private/layout_components';
import { tabDropdownBorderStyle } from '../ContactButtonStyles/TabContent/TabContent.ve.css';

export const ButtonWithOptions = forwardRef<
  HTMLButtonElement,
  ButtonProps & {
    children: React.ReactNode;
  }
>(({ children }, ref) => (
  <Container
    position="relative"
    zIndex="1"
    paddingX="0"
    marginBottom={{ default: '6', sm: '0', md: '6' }}
    width="auto"
    display="flex"
  >
    <Box
      as="button"
      className={tabDropdownBorderStyle}
      ref={ref}
      display="flex"
      width="100%"
      alignItems="center"
      justifyContent="center"
      height="42px"
      borderRadius="md"
      color="grey_1100"
      fontWeight="semibold"
      borderColor={{ default: 'black', hover: 'transparent' }}
      borderWidth="sm"
      borderStyle="solid"
      backgroundColor={{ default: 'white', hover: 'grey_900' }}
    >
      {children}
    </Box>
  </Container>
));

ButtonWithOptions.displayName = 'ButtonWithOptions';
